import { ProjectTypeDto } from './dto/project-type.dto';
import { ApiService } from '../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { ProjectTypeSearchDto } from './dto/project-type-search.dto';

@Injectable({
  providedIn: 'root',
})
export class ProjectTypeService {
  constructor(private _apiService: ApiService) {}

  search(searchDto: ProjectTypeSearchDto, forceRefresh?: boolean): Promise<PagedResultGeneric<ProjectTypeDto>> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged('ProjectTypes', searchDto, cacheOptions, true);
  }

  get(projectTypeId: number): Promise<ProjectTypeDto> {
    return this._apiService.get(`ProjectType?id=${projectTypeId}`, null, true);
  }

  create(projectType: ProjectTypeDto): Promise<number> {
    return this._apiService.post('ProjectTypes', projectType, true);
  }

  update(projectType: ProjectTypeDto): Promise<void> {
    return this._apiService.put('ProjectType', projectType, true);
  }

  delete(id: number): Promise<void> {
    return this._apiService.delete(`ProjectType?id=${id}`, true);
  }
}
